// react
import { useContext, useEffect } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// context
import { ContextBanner, ContextDocsUser } from '../../../App.context';
import { ContextProjects } from '../../layouts/Providers/Providers.context';

// layouts
import { Authenticated } from '../../layouts/Authenticated/Authenticated';

// ui
import { Program } from '../../ui/Program/Program';
import { Transactions } from '../../ui/Transactions/Transactions';

// mui
import { Grid } from '@mui/material';

export const PageDashboard = () => {
	// hooks
	const { t } = useTranslation();

	// context
	const { setBanner } = useContext(ContextBanner);
	const { docsUser, isLoadingDocsUser } = useContext(ContextDocsUser);
	const { isLoadingProjects, projects } = useContext(ContextProjects);

	// set onboard banner
	useEffect(() => {
		/*
		if (!isLoadingDocsUser && !docsUser.length) {
			setBanner({
				actions: [
					{
						children: t('setupAccount'),
						color: 'primary',
						component: RouterLink,
						to: '/profile',
						variant: 'contained',
					},
				],
				message: t('alert.uploadIdentifications'),
			});
		}
		*/

		return () => {
			setBanner(null);
		};
	}, [docsUser, isLoadingDocsUser, setBanner, t]);

	return (
		<Authenticated>
			<Grid container spacing={2}>
				{projects[0]?.program && (
					<Grid item xs={12}>
						<Program isLoading={isLoadingProjects} project={projects[0]} />
					</Grid>
				)}
				<Grid item xs={12}>
					<Transactions />
				</Grid>
			</Grid>
		</Authenticated>
	);
};
